import { render, staticRenderFns } from "./c-content-chart-flat-pie@.vue?vue&type=template&id=5ed4ed63&scoped=true&"
import script from "./c-content-chart-flat-pie@.vue?vue&type=script&lang=ts&"
export * from "./c-content-chart-flat-pie@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4ed63",
  null
  
)

export default component.exports